import { NgModule } from "@angular/core";
import { ErrorHandlerService } from "./error-handler.service";

@NgModule({
  declarations: [],
  imports: [],
  providers: [ErrorHandlerService],
})
export class ErrorHandlerModule {}
